<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="orange" class="card_header">
            <div>
              <h4 class="title">Reservations</h4>
              <p class="category">Check-in or check-out</p>
            </div>

            <md-field class="card_filter">
              <label>Status Filter</label>
              <md-select v-model="statusFilter" @change="applyStatusFilter">
                <md-option value="">All</md-option>
                <md-option v-for="status in statuses" :key="status.id" :value="status.id">
                  {{ status.name }}
                </md-option>
              </md-select>
            </md-field>
          </md-card-header>

          <md-card-content v-if="filteredReservations.length">
            <md-table v-model="filteredReservations" table-header-color="orange">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Guest Name" >
                  <p @click="reserveDetail(item)" class="reservation_table-name">
                    {{item.first_name}} {{ item.last_name }}
                  </p>
                </md-table-cell>
                <md-table-cell md-label="Listing name">{{ item.listing.external_listing_name }}</md-table-cell>
                <md-table-cell md-label="Check-in date">{{ item.start_date }}</md-table-cell>
                <md-table-cell md-label="Check-out date">{{ item.end_date }}</md-table-cell>
                <md-table-cell md-label="Status" :style="{ color: getStatusColor(item.status.id) }">{{getStatusById(item.status.id) }}</md-table-cell>
                <md-table-cell md-label="">
                  <span @click="openSelect(item.id)">
                    <md-icon>edit</md-icon>
                  </span>
                </md-table-cell>
                <md-table-cell md-label="">
                  <span @click="openDelete(item.id)">
                    <md-icon>delete</md-icon>
                  </span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
<!--  edit -->
    <md-dialog :md-active.sync="showDialog" class="custom-dialog">
      <md-dialog-title>Change status</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <md-field>
          <label>Status</label>
          <md-select v-model="change_status.status_id" name="bed_type" id="bed_type">
            <md-option
                v-for="item in statuses"
                :key="item.id"
                :value="item.id">
              {{ item.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>

      <md-dialog-actions>
        <md-button class="md-secondary" @click="showDialog = false">Close</md-button>
        <md-button class="md-primary" @click="onConfirm()" :disabled="!change_status.status_id">Change</md-button>
      </md-dialog-actions>
    </md-dialog>
<!--    -->

<!-- del   -->
    <md-dialog :md-active.sync="showDelDialog" class="custom-dialog">
      <md-dialog-title>Delete Reservation</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <h4>Are you sure you want to delete this reservation?</h4>
        <br>
        <p>This action cannot be undone and the reservation details will be permanently removed.</p>
        <p v-if="delError" class="py-3 text-danger font-weight-bold">{{delError}}</p>
      </div>


      <md-dialog-actions>
        <md-button class="md-secondary" @click="showDelDialog = false">Close</md-button>
        <md-button class="md-primary" @click="onConfirmDelete()">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>
<!--    -->
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "Reservations",
  data() {
    return {
      showDialog: false,
      showDelDialog: false,
      delReservationId: null,
      allReservations: [],
      statusFilter: "",
      statuses: [],
      change_status: {
        reservation_id: null,
        status_id: null
      },
      delError: ''
    }
  },
  computed: {
    filteredReservations() {
      if (!this.statusFilter) {
        return this.allReservations;
      }
      return this.allReservations.filter(
          res => res.status.id === this.statusFilter
      );
    }
  },
  created() {
    this.getSelectList()
    .then(res => {
      this.statuses = res.data.data.status
    })
  },
  mounted() {
    this.getAllReservations()
  },
  methods: {
    ...mapActions(['getReservationsAll', 'getSelectList', 'changeResStatus', 'removeReservation']),
    getStatusColor(statusId) {
      switch (statusId) {
        case 1: return '#fb8c00';
        case 2: return '#ff0000';
        case 3: return '#009ff1';
        case 4: return '#ff0099';
        case 5: return '#5b5b5b';
        case 6: return '#25b300';
        default: return 'black';
      }
    },
    applyStatusFilter() {
      // This method can be used if you need to trigger API search instead of local filtering
      console.log("Filter applied:", this.statusFilter);
    },
    getAllReservations() {
      this.getReservationsAll()
          .then(res => {
            if(res.data) {
              this.allReservations = res.data.data
            }
          })
    },
    onConfirmDelete() {
      this.delError = ''
      this.removeReservation(this.delReservationId)
      .then(res => {
        if(res.status == 200) {
          this.showDelDialog = !this.showDelDialog
          this.delReservationId = null
          this.getAllReservations()
        }
        if(res.status == 404) {
          this.delError = res.response.data.error
        }
      })
    },
    reserveDetail(item) {
      // this.$router.push({name: 'ReservationDetails', params: {unique_hash: item.unique_hash}})
    },
    getStatusById(id) {
      const status = this.statuses.find(b => b.id === id);
      return status ? status.name : 'Unknown';
    },
    openSelect(id) {
      this.change_status.status_id = null
      this.change_status.reservation_id = id
      this.showDialog = true
    },
    openDelete(id) {
      this.delError = ''
      this.delReservationId = id
      this.showDelDialog = true
    },
    onConfirm () {
      this.changeResStatus(this.change_status)
          .then(res => {
            // if(res.status == 200 || res.status == 201) {
            //   this.selectedId = null
            //   this.active = false
            //   this.getListings()
            // }
            this.getAllReservations()
            this.showDialog = false
          })
    },

  }
}
</script>

<style scoped lang="scss">
::v-deep .reservation {
  &_table {
    &-name {
      font-size: 18px;
      font-weight: 500;
      color: orange;
      cursor: pointer;
      &:hover {
        color: #4e555b;
      }
    }
  }
}
::v-deep .md-dialog-container {
  max-width: 500px !important;
  max-height: 300px !important;
  width: 100% !important;
  height: 100% !important;
}
.card {
  &_header {
    display: flex;
    justify-content: space-between;
    & label {
      color: #ffffff !important;
    }
  }
  &_filter {
    width: 200px;
    margin-right: 30px;
    ::v-deep .md-menu .md-input {
      -webkit-text-fill-color: white !important;
    }
    &::before,
    &::after,
    &:not(.md-disabled):after {
      background-color: #ffbd69 !important;
    }
  }

}
</style>
